import React from 'react';
import cn from 'classnames';

import styles from './ExpirationBadge.module.scss';
// TODO: need to check the translation from POEditor for aria label
export function ExpirationBadge({ className, message }: { className?: string; message: string }) {
  return (
    <span data-type='expirationBadge' role='status' aria-label='Expiration Badge' className={cn(styles.expiresBadge, className)}>
      {message}
    </span>
  );
}
